const noop = () => {};
const logLevels = ['debug', 'info', 'warn', 'error'];
const logger = {};
logLevels.forEach(level => { logger[level] = noop; });

export default {
  install: (app) => {
    app.config.globalProperties.$log = logger;
    app.provide('logger', logger);
  }
};
